import PaymentMethodDetail from './PaymentMethodDetail'

export default PaymentMethodDetail
